import {
  UnicoCheckBuilder,
  UnicoThemeBuilder,
  UnicoConfig,
  SDKEnvironmentTypes,
} from 'unico-webframe';
import literals from '~theme/literals';

/**
 * The SDK paints its own canvas and never sees the page stylesheet, so these
 * have to be resolved values rather than --fuel-* custom properties.
 */
export const unicoColors = {
  silhouetteSuccess: literals.icon.success,
  silhouetteError: literals.icon.danger,
  silhouetteNeutral: literals.icon.inverted,
  background: literals.surface.default,
  text: literals.text.strong,
  buttonBackground: literals.surface.primary,
  buttonText: literals.icon.inverted,
};

const unicoTheme = new UnicoThemeBuilder()
  .setColorSilhouetteSuccess(unicoColors.silhouetteSuccess)
  .setColorSilhouetteError(unicoColors.silhouetteError)
  .setColorSilhouetteNeutral(unicoColors.silhouetteNeutral)
  .setBackgroundColor(unicoColors.background)
  .setColorText(unicoColors.text)
  .setBackgroundColorComponents(unicoColors.background)
  .setColorTextComponents(unicoColors.text)
  .setBackgroundColorButtons(unicoColors.buttonBackground)
  .setColorTextButtons(unicoColors.buttonText)
  .setBackgroundColorBoxMessage(unicoColors.background)
  .setColorTextBoxMessage(unicoColors.text)
  .setHtmlPopupLoading(` `)
  .build();

const urlPathModels = `${window.location.protocol}//${window.location.host}/models`;

const getUnicoMode = (): SDKEnvironmentTypes => {
  return process.env.REACT_APP_ENVIROMENT === 'production'
    ? SDKEnvironmentTypes.PROD
    : SDKEnvironmentTypes.UAT;
};

export const unicoConfig = new UnicoConfig()
  .setHostname(process.env.REACT_APP_APPLICATION_HOSTNAME)
  .setHostKey(process.env.REACT_APP_UNICO_SDK);

export default new UnicoCheckBuilder()
  .setTheme(unicoTheme)
  .setModelsPath(urlPathModels)
  .setResourceDirectory('/resources')
  .setEnvironment(getUnicoMode())
  .build();
